import React, { PureComponent } from 'react';
import { Checkbox, Row, Col } from 'antd';
import { language } from '../../../language';
import { ColorPicker } from '../../tools';
export class ShowContent extends PureComponent<any> {
    select = (showContent) => {
        const { onChange } = this.props;
        onChange(showContent);
    };

    render() {
        console.log('showContent-props', this.props);
        const { value, getFieldDecorator, hideMarketPrice, contentBox } = this.props;
        return (
            <Checkbox.Group
                style={{ width: '100%', marginTop: '8px' }}
                value={value}
                onChange={this.select}
            >
                <Row className="show-content">
                    {contentBox.indexOf('buy') != -1 && (
                        <Col span={24}>
                            <Checkbox value="buy">
                                {language.getText('components.Products.buy')}
                            </Checkbox>
                        </Col>
                    )}
                    {contentBox.indexOf('name') != -1 && (
                        <Col span={24}>
                            <Checkbox value="name">
                                {language.getText('components.Products.name')}
                            </Checkbox>
                        </Col>
                    )}
                    {contentBox.indexOf('price') != -1 && (
                        <Col className="show-content-item" span={24}>
                            <Checkbox value="price">
                                {language.getText('components.Products.price')}
                            </Checkbox>
                            {getFieldDecorator('showContentColor.price')(<ColorPicker />)}
                        </Col>
                    )}
                    {contentBox.indexOf('marketPrice') != -1 && (
                        <Col className="show-content-item" span={24}>
                            <Checkbox value="marketPrice">
                                {language.getText('components.Products.marketPrice')}
                            </Checkbox>
                            {getFieldDecorator('showContentColor.marketPrice')(<ColorPicker />)}
                        </Col>
                    )}
                    {/* 灵活配置 value 同商品价格 但是 展示为积分价格 */}
                    {contentBox.indexOf('pointPrice') != -1 && (
                        <Col className="show-content-item" span={24}>
                            <Checkbox value="price">
                                {language.getText('components.Products.pointPrice')}
                            </Checkbox>
                            {getFieldDecorator('showContentColor.pointPrice')(<ColorPicker />)}
                        </Col>
                    )}
                    {contentBox.indexOf('finishGrade') != -1 && (
                        <Col className="show-content-item" span={24}>
                            <Checkbox value="finishGrade">成色等级</Checkbox>
                        </Col>
                    )}
                </Row>
            </Checkbox.Group>
        );
    }
}
